import { Cloner } from '../services';

export class SortService {

	private static comparator(a: any, b: any): number {

		if ((a === null || typeof a === 'undefined') && b !== null && typeof b !== 'undefined') return 1
		if ((b === null || typeof b === 'undefined') && a !== null && typeof a !== 'undefined') return -1
		if ((a === null || typeof a === 'undefined') && (b === null || typeof b === 'undefined')) return 0
		if (typeof a !== typeof b) {
			console.error("property " + a + " and property " + b + "are not of the same type. The elements will be not sorted")
			return 0
		}

		if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
			// Isn't a number so lowercase the string to properly compare
			a = a.toLowerCase();
			a = SortService.replaceUmlauts(a)

			b = b.toLowerCase();
			b = SortService.replaceUmlauts(b)

			if (a < b) return -1;
			if (a > b) return 1;
		} else {
			// Parse strings as numbers to compare properly
			if (parseFloat(a) < parseFloat(b)) return -1;
			if (parseFloat(a) > parseFloat(b)) return 1;
		}
		return 0;
	}

	private static replaceUmlauts(text: string): string {
		let stringReplacedUmlauts = text
		stringReplacedUmlauts = stringReplacedUmlauts.replace("ä", "ae");
		stringReplacedUmlauts = stringReplacedUmlauts.replace("ö", "oe");
		stringReplacedUmlauts = stringReplacedUmlauts.replace("ü", "ue");
		stringReplacedUmlauts = stringReplacedUmlauts.replace("ß", "ss");
		return stringReplacedUmlauts
	}

	public sort(input: any, config: string = '+'): any {
		let resultList:any = []
		if (input) {
			resultList = input
			if (config) {
				let clonedInput = Cloner.shallowCopyArray(input)
				let propertyToCheck: string = config;
				let desc = propertyToCheck.substr(0, 1) === '-';

				if (!propertyToCheck || propertyToCheck === '-' || propertyToCheck === '+') {
					return !desc ? clonedInput : clonedInput.reverse();
				} else {
					let property: string = propertyToCheck.substr(0, 1) === '+' || propertyToCheck.substr(0, 1) === '-'
						? propertyToCheck.substr(1)
						: propertyToCheck;
					return clonedInput.sort(function (a: any, b: any) {
						return !desc
							? SortService.comparator(a[property], b[property])
							: -SortService.comparator(a[property], b[property]);
					});
				}
			}

		}
		return resultList
	}
}



// WEBPACK FOOTER //
// ./src/app/services/sort.service.ts